import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = ({ pageRange }) => {
    const height = 39 * (pageRange + 1)
    const body = new Array(pageRange + 1).fill(null).map((i, ind) => {
        const yStrip = ind ? (39 * ind + 15) + '' : '19'
        return (
            <React.Fragment key={ind}>                
                {
                    ind ?
                    <>
                        <rect x='15' y={yStrip} rx='3' ry='3' width='14' height='14' />
                        <rect x='37' y={yStrip} rx='3' ry='3' width='112' height='14' />
                        <rect x='169' y={yStrip} rx='3' ry='3' width='60' height='14' />
                        <rect x='294' y={yStrip} rx='3' ry='3' width='63' height='14' />
                        <rect x='377' y={yStrip} rx='3' ry='3' width='51' height='14' />
                        <rect x='448' y={yStrip} rx='3' ry='3' width='20' height='14' />
                        <rect x='510' y={yStrip} rx='3' ry='3' width='110' height='14' />
                        <rect x='641' y={yStrip} rx='3' ry='3' width='190' height='14' />
                        <rect x='851' y={yStrip} rx='3' ry='3' width='100' height='14' />
                        <rect x='1033' y={yStrip} rx='3' ry='3' width='20' height='14' />
                        <rect x='1153' y={yStrip} rx='3' ry='3' width='20' height='14' />
                        <rect x='1306' y={yStrip} rx='3' ry='3' width='80' height='14' />
                    </> :
                    <>
                        <rect x='15' y={yStrip} rx='3' ry='3' width='14' height='14' />
                        <rect x='37' y={yStrip} rx='3' ry='3' width='112' height='14' />
                        <rect x='169' y={yStrip} rx='3' ry='3' width='106' height='14' />
                        <rect x='294' y={yStrip} rx='3' ry='3' width='63' height='14' />
                        <rect x='377' y={yStrip} rx='3' ry='3' width='51' height='14' />
                        <rect x='448' y={yStrip} rx='3' ry='3' width='38' height='14' />
                        <rect x='510' y={yStrip} rx='3' ry='3' width='110' height='14' />
                        <rect x='641' y={yStrip} rx='3' ry='3' width='190' height='14' />
                        <rect x='851' y={yStrip} rx='3' ry='3' width='160' height='14' />
                        <rect x='1033' y={yStrip} rx='3' ry='3' width='100' height='14' />
                        <rect x='1153' y={yStrip} rx='3' ry='3' width='133' height='14' />
                        <rect x='1306' y={yStrip} rx='3' ry='3' width='136' height='14' />
                    </>
                }
            </React.Fragment>
        )
    })

    return (
        <ContentLoader
            speed={2}
            width={1464}
            height={height}
            viewBox={`0 0 1464 ${height}`}
            backgroundColor='#f3f3f3'
            foregroundColor='#ecebeb'
        >
            <>
                {body}
            </>        
        </ContentLoader>
    )
}

export default Loader